import React from "react";
import {
  FooterContainer,
  FooterContent,
  FooterLogo,
  FooterLogoBox,
  FooterLogoContent,
  FooterMenu, FooterMenuLink
} from "../../Style/Footer";
import {NavLink} from "react-router-dom";
import {DropDownText, HeaderDropDown, HeaderDropDownBox, HeaderMenuLink} from "../../Style/Header";

export const Footer = () => {

  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogoBox>
          <FooterLogo/>
          <FooterLogoContent>
            <p>Контактное лицо -</p>
            <p>Дзебоева Зарина Юрьевна</p>
            <p>Тел.: +7 (495) 969-26-17</p>
            <p>(доб. 1246)</p>
            <p>dzeboeva@apkpro.ru</p>
          </FooterLogoContent>
        </FooterLogoBox>

        <FooterMenu>
          <HeaderDropDownBox>
            <HeaderMenuLink>
              Конкурс
            </HeaderMenuLink>
            <HeaderDropDown>
              <NavLink to={'/about'}>
                <DropDownText>
                  О конкурсе
                </DropDownText>
              </NavLink>
              <NavLink to={'/topic'}>
                <DropDownText>
                  Тематические направления
                </DropDownText>
              </NavLink>
              <NavLink to={'/calendar'}>
                <DropDownText>Календарь</DropDownText>
              </NavLink>
            </HeaderDropDown>
          </HeaderDropDownBox>
          <NavLink to={'/docs'}>
            <FooterMenuLink>
              <p>документы</p>
            </FooterMenuLink>
          </NavLink>
          <NavLink to={'/news'}>
            <FooterMenuLink>
              <p>новости</p>
            </FooterMenuLink>
          </NavLink>
        </FooterMenu>
      </FooterContent>
    </FooterContainer>
  )
}